export default __webpack_public_path__ + "c137815484a18d5a3bb4afd034fbb129.svg";